import Footer from 'components/Footer';
import React, { useEffect } from 'react'

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className='contact_head contact' >
      <h2>CONTACT</h2>
      Contact eKsys Service
      </div>


      {/* <div className='padding_div' /> */}
      <div className='about_head_intro contact'>
      오시는길
      <span></span>
      </div>

      {/* <div className='contact_con'>
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6329.777835278039!2d127.06591300000001!3d37.510538!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca441440e621b%3A0x68a2c4526f68dd59!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDthYztl6TrnoDroZwxMTPquLggNw!5e0!3m2!1sko!2skr!4v1712304712472!5m2!1sko!2skr" width="50%" height="650" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        <div className='contact_explain'>
          <div className='contact_map'>
            <img src='images/icon_map.png' />
            <h2>오시는 길</h2>
            <span>서울특별시 강남구 테헤란로113길 7 백제아트센타 별관내 4층</span>
          </div>
          

          <div className='contact_map'>
            <img src='images/icon_time.png' />
            <h4>TEL.</h4><a href='tel:025561764' >02-556-1764</a>
          </div>

          <div className='contact_map'>
            <img src='images/icon_time.png' />
            <h4>FAX.</h4><a href='tel:025561735' >02-556-1735</a>
          </div>

          <div className='contact_map'>
            <img src='images/icon_mail.png' />
            <h4>E-Mail.</h4><a href="mailto:biz@eksys.co.kr">biz@eksys.co.kr</a>
          </div>
        </div>
      </div> */}
      <div className='contact_content'>
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6329.777835278039!2d127.06591300000001!3d37.510538!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca441440e621b%3A0x68a2c4526f68dd59!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDthYztl6TrnoDroZwxMTPquLggNw!5e0!3m2!1sko!2skr!4v1712304712472!5m2!1sko!2skr" width="100%" height="650" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        <div className='contact_explain_con'>
          <div className='contact_map'>
            <img src='images/con_map.png' />
            <h2>오시는 길</h2>
            <span>서울특별시 강남구 테헤란로113길 7 백제아트센타 별관내 4층</span>
          </div>
          

          <div className='contact_map'>
            <img src='images/con_phone.png' />
            <h4>TEL.</h4><a href='tel:025561764' >02-556-1764</a>
          </div>

          <div className='contact_map'>
            <img src='images/con_fax.png' />
            <h4>FAX.</h4><a href='tel:025561735' >02-556-1735</a>
          </div>

          <div className='contact_map'>
            <img src='images/con_mail.png' />
            <h4>E-Mail.</h4><a href="mailto:biz@eksys.co.kr">biz@eksys.co.kr</a>
          </div>
        </div>
      </div>

      {/* <div className='padding_div' /> */}
      <Footer/>
    </>
  )
}

export default Contact
